module.exports = __webpack_public_path__ + "media/images/front/home/cards/card_6-3e5d9e415f251465619c885d0e32e056.jpg";